<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="承运商代码">
            <el-input
              v-model="formData.carrierNo"
              placeholder="系统自动生成"
              disabled
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="承运商名称" prop="carrierName">
            <el-input
              v-model="formData.carrierName"
              placeholder="请输入承运商名称"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="承运商简称" prop="carrierShortName">
            <el-input
              v-model="formData.carrierShortName"
              placeholder="请输入承运商简称"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="结算承运商">
            <dict-select
              filterable
              clearable
              v-model="formData.parentCarrierNo"
              url="/master/carrier/info/select/parent/all"
              placeholder="请选择结算承运商"
              :disabled="isEdit"
              size="small"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="承运商类型">
            <dict-select
              filterable
              clearable
              v-model="formData.carrierType"
              placeholder="请选择承运商类型"
              default
              :body="carrierTypeDictParams"
              size="small"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="营业执照号" prop="businessLicense">
            <el-input
              v-model="formData.businessLicense"
              placeholder="请输入营业执照号"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="成立日期">
            <el-date-picker
              type="date"
              v-model="formData.establishmentDate"
              placeholder="选择成立日期日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="法定代表人" prop="legalRepresentative">
            <el-input
              v-model="formData.legalRepresentative"
              placeholder="请输入法定代表人"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="注册资金" prop="registeredCapital">
            <el-input
              v-model="formData.registeredCapital"
              placeholder="请输入注册资金"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="注册地址">
            <el-input
              v-model="formData.registeredAddress"
              placeholder="请输入注册地址"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="经营地址">
            <el-input
              v-model="formData.businessAddress"
              placeholder="请输入经营地址"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="营业执照有效期">
            <el-date-picker
              type="date"
              v-model="formData.businessLicenseValidity"
              placeholder="请选择营业执照有效期"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="道路运营许可证有效期">
            <el-date-picker
              type="date"
              v-model="formData.roadOperationLicenseValidity"
              placeholder="请选择道路运营许可证有效期"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="安全准入备案证有效期">
            <el-date-picker
              type="date"
              v-model="formData.safetyAccessValidity"
              placeholder="请选择道安全准入备案证有效期"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="ISO9001有效期">
            <el-date-picker
              type="date"
              v-model="formData.isoOneValidity"
              placeholder="请选择ISO9001有效期"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="ISO14001有效期">
            <el-date-picker
              type="date"
              v-model="formData.isoTwoValidity"
              placeholder="请选择ISO14001有效期"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="ISO18001有效期">
            <el-date-picker
              type="date"
              v-model="formData.isoThreeValidity"
              placeholder="请选择ISO18001有效期"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="SQAS报告号">
            <el-input
              v-model="formData.sqasNumber"
              placeholder="请输入SQAS报告号"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="运输许可资质">
            <el-input
              v-model="formData.transportationLicense"
              placeholder="请输入运输许可资质"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="开户银行" prop="depositBank">
            <el-input
              v-model="formData.depositBank"
              placeholder="请输入开户银行"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input
              v-model="formData.bankAccount"
              placeholder="请输入银行账号"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="账号名称" prop="bankAccountName">
            <el-input
              v-model="formData.bankAccountName"
              placeholder="请输入账号名称"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="发票抬头" prop="invoiceTitle">
            <el-input
              v-model="formData.invoiceTitle"
              placeholder="请输入发票抬头"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="税号" prop="taxNumber">
            <el-input
              v-model="formData.taxNumber"
              placeholder="请输入税号"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="开票地址" prop="invoiceAddress">
            <el-input
              v-model="formData.invoiceAddress"
              placeholder="请输入开票地址"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="固定电话" prop="phoneNo">
            <el-input
              v-model.number="formData.phoneNo"
              placeholder="请输入固定电话"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="财务代码">
            <el-input
              v-model="formData.financialCode"
              placeholder="请输入财务代码"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="结算条件">
            <dict-select
              filterable
              clearable
              v-model="formData.carrierSettlementCondition"
              placeholder="请选择结算条件"
              default
              :body="carrierSettlementConditionDictParams"
              size="small"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="是否自动生成账单" prop="isAutoSettlement">
            <el-radio-group v-model="formData.isAutoSettlement" size="small">
              <el-radio label="Y">自动</el-radio>
              <el-radio label="N">手动</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="账单生成日" prop="carrierSettlementDate">
            <el-input
              size="small"
              v-model="formData.carrierSettlementDate"
              placeholder="请输入账单生成日"
              :disabled="isDisableCarrierSettlementDate"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="是否是快递公司" prop="isExpress">
            <el-radio-group v-model="formData.isExpress" size="small">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>˝
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="快递公司代码">
            <el-input
              v-model="formData.apiCarrierNo"
              placeholder="请输入快递公司代码"
              :disabled="isDisableApiCarrierNo"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          label="道路运营许可证经营范围"
          prop="roadOperationLicenseScope"
        >
          <el-input
            v-model="formData.roadOperationLicenseScope"
            placeholder="请输入道路运营许可证经营范围"
            type="textarea"
            size="small"
          >
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="备注信息" prop="carrierRemarks">
          <el-input
            v-model="formData.carrierRemarks"
            placeholder="请输入备注信息"
            type="textarea"
            size="small"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="有效状态" prop="carrierStatus">
          <el-radio-group v-model="formData.carrierStatus" size="small">
            <el-radio label="Y">有效</el-radio>
            <el-radio label="N">无效</el-radio>˝
          </el-radio-group>
        </el-form-item>
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mb-2">
      <el-button v-if="!disabled" type="primary" size="small" @click="save()"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    isEdit: Boolean,
    params: { type: Object, default: () => {} },
  },
  components: {},
  data() {
    return {
      carrierSettlementConditionDictParams: {
        type: 'carrierSettlementCondition',
      },
      carrierTypeDictParams: { type: 'carrierType' },
      isDisableCarrierSettlementDate: false,
      isDisableApiCarrierNo: false,
      formData: { carrierStatus: 'Y', isAutoSettlement: 'Y', isExpress: 'Y' },
      rules: {
        businessLicense: [
          {
            pattern: /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/,
            message: '请输入正确的营业执照号',
            trigger: 'blur',
          },
        ],
        invoiceTitle: [
          { max: 66, message: '发票抬头 字数最多为66位', trigger: 'blur' },
        ],
        bankAccountName: [
          { max: 16, message: '银行账号 字数最多为16位', trigger: 'blur' },
        ],
        depositBank: [
          { max: 16, message: '开户银行 字数最多为16位', trigger: 'blur' },
        ],
        legalRepresentative: [
          { max: 16, message: '法定代表人 字数最多为16位', trigger: 'blur' },
        ],
        registeredCapital: [
          { max: 20, message: '注册资金 字数最多为20位', trigger: 'blur' },
        ],
        registeredAddress: [
          { max: 166, message: '注册地址 字数最多为166位', trigger: 'blur' },
        ],
        businessAddress: [
          { max: 166, message: '经营地址 字数最多为166位', trigger: 'blur' },
        ],
        invoiceAddress: [
          { max: 166, message: '开票地址 字数最多为166位', trigger: 'blur' },
        ],
        roadOperationLicenseScope: [
          {
            max: 666,
            message: '道路运营许可证经营范围 字数最多为666位',
            trigger: 'blur',
          },
        ],
        carrierRemarks: [
          {
            max: 666,
            message: '备注信息 字数最多为666位',
            trigger: 'blur',
          },
        ],
        carrierName: [
          { required: true, message: '请输入承运商名称', trigger: 'blur' },
          { max: 16, message: '承运商名称 字数最多为16位', trigger: 'blur' },
        ],
        carrierShortName: [
          { required: true, message: '请输入承运商简称', trigger: 'blur' },
          { max: 16, message: '承运商简称 字数最多为16位', trigger: 'blur' },
        ],
        isAutoSettlement: [
          {
            required: true,
            message: '请选择是否自动生成账单',
            trigger: 'change',
          },
        ],
        isExpress: [
          {
            required: true,
            message: '请选择是否是快递公司',
            trigger: 'change',
          },
        ],
        carrierStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' },
        ],
        carrierSettlementDate: [
          {
            pattern: /^([1-9]|[1-2]\d|3[0-1])$/,
            message: '请输入正确的账单生成日',
            trigger: '',
          },
        ],
        bankAccount: [
          {
            // message: '请输入正确的银行账号',
            // pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
            validator:(rule, value, callback) => {
              let reg = /^(\d{1})(\d{14,20})$/
              let numReg = /^\d+$/
              if (reg.test(value)){
                callback()
              }else{
                if (value === null || value === undefined || value === ''){
                  callback()
                }else if (numReg.test(value) && value.length > 21){
                  this.$confirm('当前输入的账号大于21位，请确认是否正确', '确认信息', {
                    type: 'warning'
                  }).then(() => {
                    callback()
                  }).catch(() => {
                    callback(new Error('请输入15~21位的银行账号'))
                  })
                }else if (numReg.test(value) && value.length < 15){
                  this.$confirm('当前输入的账号小于15位，请确认是否正确', '确认信息', {
                    type: 'warning'
                  }).then(() => {
                    callback()
                  }).catch(() => {
                    callback(new Error('请输入15~21位的银行账号'))
                  })
                }else{
                  callback(new Error('请输入15~21位的银行账号'))
                }
              }
            },
            trigger: 'blur',
          },
        ],
        taxNumber: [
          {
            pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
            message: '请输入正确的税号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'formData.isAutoSettlement'() {
      if (this.formData.isAutoSettlement === 'N') {
        this.isDisableCarrierSettlementDate = true
        this.formData.carrierSettlementDate = ''
      } else {
        this.isDisableCarrierSettlementDate = false
      }
    },
    'formData.isExpress'() {
      if (this.formData.isExpress === 'N') {
        this.isDisableApiCarrierNo = true
        this.formData.apiCarrierNo = ''
      } else {
        this.isDisableApiCarrierNo = false
      }
    },
  },
  methods: {
    getData() {
      if (!this.params.carrierCode) return
      this.$api
        .masterCarrierDetailApi({
          carrierCode: this.params.carrierCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterCarrierSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$emit('codeChange', res.body)
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
